import { useEffect, useMemo } from 'react';
import { useTwinsStore } from '../../../stores/prioritization/twinsStore';
import { getCurrentWorkspaceId } from '../../../lib/supabaseSync';

/** Every group this agent proposed that still waits for a person, newest first. */
export function useOpenClusterProposals(agentType: string) {
  const active = useTwinsStore((s) => s.activeClusters);
  const fetchClusters = useTwinsStore((s) => s.fetchClusters);
  const workspaceId = getCurrentWorkspaceId();
  useEffect(() => {
    if (workspaceId) void fetchClusters(workspaceId);
  }, [workspaceId, fetchClusters]);
  return useMemo(
    () => active.filter((c) => c.proposedByAgent === agentType)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
    [active, agentType],
  );
}
